import script from "./RegisterLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterLocation.vue?vue&type=script&setup=true&lang=js"

import "./RegisterLocation.vue?vue&type=style&index=0&id=d44a6aa0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d44a6aa0"]])

export default __exports__